import { apiClient } from '@/services/ApiClient.js'

export class DocumentProcessService {
  getProcesses(document) {
    return apiClient
      .get('documents/' + document + '/processes')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  exportControlProcess(document) {
    return apiClient
      .get('documents/' + document + '/export-control-processes')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  getProcess(document, process) {
    return apiClient
      .get('documents/' + document + '/processes/' + process)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  updateProcess(document, process, params) {
    return apiClient
      .patch('documents/' + document + '/processes/' + process, params)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
  deleteProcess(document, process) {
    return apiClient
      .delete('documents/' + document + '/processes/' + process)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
